import { render, staticRenderFns } from "./settlementSubmit.vue?vue&type=template&id=1c069292&"
import script from "./settlementSubmit.vue?vue&type=script&lang=js&"
export * from "./settlementSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports